import { Component, computed, DestroyRef, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Services } from "src/app/services/api.service";
import { filter, Subscription, switchMap } from 'rxjs';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ACTION_ID } from 'src/app/common/constants';
import { CommonModule } from '@angular/common';
import { ModalService } from 'src/app/services/modal.service';
import { ModalNames } from 'src/app/common/modal.config';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaymentComponent } from 'src/app/components/payment/payment.component';
import { NavigationCartService } from 'src/app/components/navigation-cart/navigation.cart.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderService } from 'src/app/services/getOrder.service';
import { CartInfoBoxComponent } from 'src/app/components/cart-info-box/cart-info-box.component';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { RouterLink } from '@angular/router';
import { ProfileService } from 'src/app/services/profile.service';
import { FormDataStoreService } from 'src/app/services/form-data.store';
import { DeliveryComponent } from 'src/app/components/delivery/delivery.component';

@Component({
  selector: 'app-season-ticket',
  templateUrl: `${environment.pageFolder}/season-ticket.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/season-ticket.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, PaymentComponent, CartInfoBoxComponent, RouterLink, DeliveryComponent]
})
export class SeasonTicketComponent {
  private subscription: Subscription = new Subscription();
  eventId: number = Number(document.location.pathname?.split("/buy-season-ticket/")[1]?.split("/")[0]);
  actionId: number = Number(document.location.pathname?.split("/buy-season-ticket/")[1]?.split("/")[1]);
  subscriptionReservationActionId: number = ACTION_ID.SUBSCRIBER_TICKET_OS;
  redirectUrlFromParent: string = "group-tickets-profile/transactionCompleted";
  @Input() selectedEvent: any = null;
  @Input() parent: string | null = null;

  private formDataKey: string = '';
  dataForm: FormGroup = this.formBuilder.group({
    barcodeSeasonTicket: ['', [Validators.required]],
    barcodeMembershipCard: [''],
    termsOfSaleSeasonTicket: [false, [Validators.requiredTrue]]
  });

  errorMessage: string = "";
  membershipBarcode: any = null;
  loader = document.getElementById("loader-container");
  orderId: number | null = null;
  order: any = null;
  customerProfile: any = null;
  username: string = "";
  lastYearSeasonTicket: boolean = false;
  showPayment: boolean = false;
  showDelivery: boolean = false;
  showDeliverySubscriptionWithMember: boolean = false;
  deliverySubscription: any = null;
  page: string = environment.page;
  public readonly modalNamesEnum = ModalNames;
  readonly isBuySeasonTicketModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.BuySeasonTicket) ?? false);
  deliveryForm: FormGroup = this.formBuilder.group({
    deliverySameAs: [true]
  });
  initialCall: boolean = true;

  @ViewChild('barcodeMembershipCardInput') barcodeMembershipCardInput: any;

  constructor(
    private formBuilder: FormBuilder,
    public service: Services,
    private http: HttpClient,
    public modalService: ModalService,
    private readonly errorMessageService: ErrorMessageService,
    private translate: TranslateService,
    private navigationCartService: NavigationCartService,
    private orderService: OrderService,
    private userProfileService: GetUserProfileService,
    private profileService: ProfileService,
    private readonly destroyRef: DestroyRef,
    private readonly formDataStore: FormDataStoreService
  ) {}

  ngOnInit() {
    let enteredBarcodes = sessionStorage.getItem("enteredBarcodes");

    if(enteredBarcodes && environment.configId !== "4") {
      let enteredBarcodesParsed = JSON.parse(enteredBarcodes);
      if(enteredBarcodesParsed.memberBarcode) {
        let checkbox:any = document.getElementById("isMember");
        checkbox.checked = true;
      }

      if(enteredBarcodesParsed.gdprChecked) {
        this.dataForm.patchValue({termsOfSaleSeasonTicket: true});
        let checkbox:any = document.getElementById("terms-of-sale-season-ticket");
        checkbox.checked = true;
      }

      this.dataForm.patchValue({barcodeSeasonTicket: enteredBarcodesParsed.subscriptionBarcode});
      this.dataForm.patchValue({barcodeMembershipCard: enteredBarcodesParsed.memberBarcode});
     /*  setTimeout(() => {
        this.onSubmit();
      }, 100); */
    }

    if(environment.configId === "4") {
      if (this.selectedEvent && !this.showPayment) {
        this.formDataKey = `${ModalNames.BuySeasonTicket}-${this.selectedEvent.eventId}`;
        this.formDataStore.subscribeToForm(this.formDataKey, this.dataForm, this.destroyRef);

        this.applyMembershipValidator(this.selectedEvent);
      }

      if(this.navigationCartService.lastOrder !== 0) {
        this.orderId = this.navigationCartService.lastOrder;
      }

      this.getOrder();
      this.getCustomerProfile();
    }

    this.getMemberships();
    this.getGroupTickets();
  }

  getOrder(refresh: boolean = false) {
    const lastOrder$ = this.navigationCartService.getLastOrder();

    if (this.orderId) {
      this.orderService.getOrder(this.orderId, refresh).subscribe({
        next: (order) => {
          if(order.items[0].eventId === this.selectedEvent?.eventId) {
            this.order = order;

            if(Number(order.transactionInfo.actionId) === ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET && order.transactionInfo.deliveryDataSubmitted) {
              this.deliveryForm.patchValue({deliverySameAs: true});
            }

            if(Number(order.transactionInfo.actionId) === ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET) {
              this.callDeliverySubscription();
            } else {
              this.showPayment = true;
              this.redirectUrlFromParent = "user-profile/transactionCompleted";
            }
          }
        }
      });
    } else if (lastOrder$ && typeof lastOrder$.pipe === 'function') {
      lastOrder$
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter(response => response.data != null),
          switchMap(response => this.orderService.getOrder(response.data, refresh))
        )
        .subscribe({
          next: (order) => {
            if((order.items[0].eventId === this.selectedEvent?.eventId && this.parent === "events-list") || (this.parent === "")) {
              this.orderId = order.id;
              this.order = order;

              if(Number(order.transactionInfo.actionId) === ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET && this.order.transactionInfo.deliveryDataSubmitted ) {
                this.deliveryForm.patchValue({deliverySameAs: true});
              }

              if(Number(order.transactionInfo.actionId) === ACTION_ID.EXCLUSIVE_SUBSCRIBER_TICKET) {
                this.callDeliverySubscription();
              } else {
                this.showPayment = true;
                this.redirectUrlFromParent = "user-profile/transactionCompleted";
              }
            }
          }
      });
    }
  }

  callDeliverySubscription() {
    this.service.deliverySubscriptionWithMember(Number(this.orderId)).subscribe({
      next: (data: any) => {
        if(data.data.deliveryData.length > 0 && !this.order.transactionInfo.deliveryDataSubmitted) {
          this.showDeliverySubscriptionWithMember = true;
          this.deliverySubscription = data.data;

          this.showPayment = true;

          if(this.initialCall) {
            this.initialCall = false;
            this.setDeliveryWay();
          }
        } else {
          /*if(!this.order.transactionInfo.deliveryDataSubmitted) {
            this.showDelivery = true;
            this.showPayment = false;
          } else {
            this.showPayment = true;
            this.showDelivery = false;
          }*/

          this.showPayment = true;
          this.showDelivery = false;
        }
      }
    });
  }

  onSubmit() {
    if(GlobalConstants.isAuth !== true) {
      this.openLoginModal();

      if (environment.configId !== '4') {
        let enteredBarcodes = {
          "subscriptionBarcode": this.dataForm.value.barcodeSeasonTicket,
          "memberBarcode": this.dataForm.value.barcodeMembershipCard,
          "gdprChecked": this.dataForm.value.termsOfSaleSeasonTicket
        }
        sessionStorage.setItem("enteredBarcodes", JSON.stringify(enteredBarcodes));
      }

      return;
    }

    if (this.dataForm.invalid) {
      this.dataForm.markAllAsTouched();
      const seasonTicketControl = this.dataForm.get('barcodeSeasonTicket')!;
      const barcodeTicketControl = this.dataForm.get('barcodeMembershipCard')!;

      if (this.dataForm.get('termsOfSaleSeasonTicket')!.invalid) {
        this.errorMessage = this.errorMessageService.getErrorMessage('termsOfSaleRequired');
      } else if (seasonTicketControl.hasError('required') || barcodeTicketControl.hasError('required')) {
        this.errorMessage = this.errorMessageService.getErrorMessage('allFieldsRequired');
      } else {
        this.errorMessage = this.errorMessageService.getErrorMessage('error');
      }

      return;
    }

    this.errorMessage = '';
    this.loader!.style.display = "flex";

    sessionStorage.removeItem("enteredBarcodes");

    if(localStorage.getItem('selectedEvent')) {
      const selectedEventFromStorage = localStorage.getItem('selectedEvent');
      this.selectedEvent = selectedEventFromStorage ? JSON.parse(selectedEventFromStorage) : null;
      localStorage.removeItem('selectedEvent');
    }

    let body = {
      "actionId": this.selectedEvent.actions[0].id,
      "eventId": this.eventId || this.selectedEvent?.eventId,
      "subscriptionBarcode": this.dataForm.value.barcodeSeasonTicket,
      "memberBarcode": this.dataForm.value.barcodeMembershipCard
    }

    this.http.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/subscription`, body, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        if(environment.configId === "1") {
          document.location = `${environment.redirectUrl}/buy-season-ticket/cart/${response.data}`
        } else if(environment.configId === "4") {
          this.orderId = response.data;
          this.navigationCartService.lastOrder = response.data;
          this.getOrder();
          this.formDataStore.clearFormData(this.formDataKey);
        }
      },
      error: error => {
        if(error.error.errors[0].code === "ORA-20902") {
          this.errorMessage = this.errorMessageService.getErrorMessage("seasonTicketReservationIssued");
        } else if(error.error.errors[0].code === "ORA-20903") {
          this.errorMessage = this.errorMessageService.getErrorMessage("seasonTicketReservationCancelled");
        } else if(error.error.errors[0].code === "ORA-20904") {
          this.errorMessage = this.errorMessageService.getErrorMessage("seasonTicketReservationNotFound");
        } else if(error.error.errors[0].code === "ORA-20905") {
          this.errorMessage = this.errorMessageService.getErrorMessage("membershipNotActive");
        } else if(error.error.errors[0].code === "ORA-20906") {
          this.errorMessage = this.errorMessageService.getErrorMessage("matchingDataMembershipAndSeasonTicket") + ' ' + this.translate.instant('CONTACT_EMAIL');
        } else if(error.error.errors[0].code === "ORA-20907") {
          this.errorMessage = this.errorMessageService.getErrorMessage("membershipNotFoundWithBarcode");
        } else {
          this.errorMessage = this.errorMessageService.getErrorMessage("error");
        }
        this.loader!.style.display = "none";
      }
    })
  }

  openLoginModal() {
    if(!GlobalConstants.isAuth) {
      this.modalService.openModal(ModalNames.Login);
    }
  }

  checkValue(event: any) {}

  cancelOrder() {
    this.modalService.closeModal(ModalNames.EventModal);
    this.modalService.closeModal(ModalNames.HomepageModal);
  }

  getCustomerProfile() {
    this.userProfileService.getConnectionUserProfile().subscribe({
      next: (data: any) => {
        this.customerProfile = data.data;
        this.username = this.customerProfile.firstName + ' ' + this.customerProfile.lastName;
      }
    });
  }

  limitInputLengthForNumberic(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    let inputValue = inputEl.value.replace(/\D/g, '');
    if (inputValue.length > 12) {
      inputValue= inputValue.slice(0, 12);
    }
    inputEl.value = inputValue;
  }

  private applyMembershipValidator(event: any) {
    const memberControl = this.dataForm.get('barcodeMembershipCard')!;
    const isMembersOnly = event.actions?.some((action: any) => action.membersExclusive);

    if (isMembersOnly) {
      memberControl.setValidators([Validators.required]);
    } else {
      memberControl.clearValidators();
    }
    memberControl.updateValueAndValidity();
  }

  setDeliveryWay() {
    const isChecked = this.deliveryForm.get('deliverySameAs')?.value;

    if (isChecked) {
      let body = {
        'deliveryId': "W01_1",
        'deliveryData': {
          "email": "",
          "ime": "",
          "prezime": "",
          "adresa": "",
          "kucni_broj": "",
          "mjesto": "",
          "pbr": "",
          "drzava": "",
          "tel": "",
          "napomena": "",
        }
      }

      body.deliveryId = this.deliverySubscription.deliveryData[0].sifra;
      body.deliveryData.napomena = this.deliverySubscription.deliveryData[0].napomena;

      this.http.post(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/delivery`, body, GlobalConstants.headersCentral).subscribe({
        next: () => {
          this.getOrder(true);
        }
      });
    } else {
      this.http.delete(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/delivery`, GlobalConstants.headersCentral).subscribe({
        next: () => {
          this.getOrder(true);
        }
      });
    }
  }

  hideDeliveryFormOnPayment() {
    this.showDeliverySubscriptionWithMember = false;
  }

  prefillDataForProfileOwner(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;

    const values = {
      barcodeMembershipCard: isChecked && this.membershipBarcode ? this.membershipBarcode : '',
      barcodeSeasonTicket: isChecked && this.lastYearSeasonTicket ? this.lastYearSeasonTicket : '',
    };

    Object.entries(values).forEach(([key, value]) => {
      this.dataForm.patchValue({ [key]: value });
      const control = this.dataForm.get(key);
      control?.markAsDirty();
      control?.updateValueAndValidity();
    });
  }

  getMemberships() {
    this.profileService.getMemberships(true).subscribe({
      next: (data) => {
        const response: any = data;
        response.data?.own?.isActive && (this.membershipBarcode = response.data.own?.barcode);
      }}
    );
  }

  getGroupTickets() {
    this.loader!.style.display = "flex";

    this.profileService.getSubsribersTickets(true).subscribe({
      next: (data: any) => {
        data = data.data;

        if (data.own && data.own.ticketOwnerName && this.username) {
          if (data.own.ticketOwnerName.toUpperCase() === this.username.toUpperCase() && data.own.isActive) {
            this.lastYearSeasonTicket = data.own.barcode;
          }
        }

        data?.others?.forEach((ticket: any) => {
          if (!this.username) {
            const interval = setInterval(() => {
              if (this.username) {
                clearInterval(interval);
                if (ticket.ticketOwnerName.toUpperCase() === this.username.toUpperCase() && ticket.isActive) {
                  this.lastYearSeasonTicket = ticket.barcode;
                }
              }
            }, 100);
          } else {
            if (ticket.ticketOwnerName.toUpperCase() === this.username.toUpperCase() && ticket.isActive) {
              this.lastYearSeasonTicket = ticket.barcode;
            }
          }
        });

        this.loader!.style.display = "none";
      }
    });
  }

  emitOnSubmitDeliveryData() {
    this.getOrder(true);
  }
}
